<script lang="ts">
  import { mdiCalendarClock, mdiCalendarMonthOutline } from "@mdi/js"
  import ToggleCTA from "@kontextwerk/web-sdk/ui/actions/ToggleCTA.svelte"
  import {
    CALENDAR_GRID_MINUTES,
    type CalendarGridMinutes,
    type CalendarView,
  } from "../../_shared/_logic/display-scale"
  const gridId = $props.id()
  let {
    view,
    gridMinutes,
    onViewChange,
    onGridChange,
  }: {
    view: CalendarView
    gridMinutes: CalendarGridMinutes
    onViewChange: (value: CalendarView) => void
    onGridChange: (value: CalendarGridMinutes) => void
  } = $props()
</script>

<div class="calendar-controls" aria-label="Kalenderdarstellung">
  {#if view === "timeline"}
    <div class="grid-selection">
      <!-- A sibling label keeps the overlay's label > select form styles out of this toolbar. -->
      <label for={gridId}>Zeitraster</label>
      <select
        id={gridId}
        value={gridMinutes}
        onchange={(event) => onGridChange(Number(event.currentTarget.value) as CalendarGridMinutes)}
      >
        {#each CALENDAR_GRID_MINUTES as minutes}
          <option value={minutes}>{minutes} Minuten</option>
        {/each}
      </select>
    </div>
  {/if}
  <div class="view-selection" role="group" aria-label="Ansicht">
    <span>Ansicht</span>
    <ToggleCTA
      options={[
        { value: "timeline", label: "Zeitplan", icon: mdiCalendarClock },
        { value: "overview", label: "Übersicht", icon: mdiCalendarMonthOutline },
      ]}
      value={view}
      darkMode={false}
      small={true}
      onChange={(value) => onViewChange(value === "overview" ? "overview" : "timeline")}
    />
  </div>
</div>

<style>
  .calendar-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 24px;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 12px;
    color: var(--cal-text, #2f4858);
  }
  .view-selection,
  .grid-selection {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 500;
    color: var(--cal-text-muted, #617481);
  }
  .view-selection > span {
    color: inherit;
  }
  .grid-selection > label {
    display: block;
    position: static;
    width: auto;
    max-width: none;
    height: auto;
    max-height: none;
    flex: 0 0 auto;
    font: inherit;
    color: inherit;
  }
  select {
    appearance: auto;
    font: inherit;
    line-height: 20px;
    width: 136px;
    min-height: 36px;
    padding: 6px 14px;
    cursor: pointer;
    border: 1px solid var(--cal-border-strong, #dce2e6);
    border-radius: 0;
    background: var(--cal-bg, #fff);
    color: var(--cal-text, #2f4858);
  }
  select:focus-visible {
    outline: 2px solid var(--cal-text, #2f4858);
    outline-offset: -2px;
  }
  @media (pointer: coarse) {
    select {
      min-height: 44px;
    }
  }
</style>
